



















































import { Component, Vue, Prop } from 'vue-property-decorator'
import { Order, CardDistribution } from '@/models/index'

@Component({
  name: 'CardDistributionEditDrawer',
  components: {
  }
})
export default class extends Vue {
  @Prop({ required: true }) private visible!: boolean
  @Prop({ required: true }) private order!: Order

  private direction = 'rtl'

  isFreeFaceValue(row: CardDistribution) {
    return row.sku?.faceValueFree && !row.sku?.discardedAt
  }

  get faceValueAvailable() {
    return this.order.giftCard.skus
      .filter(e => !e.faceValueFree && !e.discardedAt)
      .map(e => ({ label: `${e.faceValue} €`, value: e.id }))
  }
}
